import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/Home'
import Product from '@/pages/Product/Product'
import Problem from '@/pages/Problem/Problem'
import technology from '@/pages/technology/technology'
import News from '@/pages/News/News'
import NewsDetail from '@/pages/News/NewsDetail'
import About from '@/pages/about/About'
import NotFound from '@/pages/notfound/NotFound'
import MHome from '@/pages/mhome/MHome'
import MProduct from '@/pages/mhome/MProduct'
import MContact from '@/pages/mhome/MContact'
import MTechnology from '@/pages/mhome/MTechnology'
import MNews from '@/pages/mhome/MNews'
import MNewsDetail from '@/pages/mhome/MNewsDetail'
import Tax from '@/pages/mhome/MTax'
import Card from '@/pages/mhome/Card'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    }, {
      path: '/product',
      name: 'Product',
      component: Product
    }, {
      path: '/problem',
      name: 'Problem',
      component: Problem
    }, {
      path: '/technology',
      name: 'technology',
      component: technology
    }, {
      path: '/news',
      name: 'News',
      component: News
    }, {
      path: '/newsdetail/:id',
      name: 'NewsDetail',
      component: NewsDetail
    }, {
      path: '/about',
      name: 'About',
      component: About
    }, {
      path: '/mhome',
      name: 'MHome',
      component: MHome
    }, {
      path: '/tax',
      name: 'Tax',
      component: Tax
    },
    {
      path: '/card',
      name: 'Card',
      component: Card
    }, {
      path: '/mproduct',
      name: 'MProduct',
      component: MProduct
    }, {
      path: '/mcontact',
      name: 'MContact',
      component: MContact
    }, {
      path: '/mtechnology',
      name: 'MTechnology',
      component: MTechnology
    }, {
      path: '/mnews',
      name: 'MNews',
      component: MNews
    }, {
      path: '/mnewsdetail/:id',
      name: 'MNewsDetail',
      component: MNewsDetail
    }, {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ],
  scrollBehavior (to, from, savePosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js